import React, { useState } from 'react';
import { get, includes, isEmpty } from 'lodash';
import { array, func, string, object, any, oneOfType, number, bool } from 'prop-types';
import { Tooltip } from 'antd';
import QueryGetAssignedInfo from '../../graphql/getAssignInfo';
import { Text, Loading, Row, Button, HasPermissions, Truncate, AppIcon, FlexContainer, MobileWrapper } from '../../common';
import UserSearchSelect from '../Users/UserSearchSelect';
import ModalOpener from '../../globals/ModalOpener';
import { cleanOrderId } from '../../../utils/misc';

const OrderPickerManager = ({ filters, id, onSelectPicker, maxWidth, render, permissions, salesChannelId, pickerInfo, pickingInfo, assignDisabled, hasPermissionToThisStore, styles }) => {
    const [initialState, setInitialState] = useState(pickerInfo !== undefined);
    const validStatuses = ['1', '2', '7', '20'];
    const resolvePickerName = (data) => {
        if (initialState) {
            const firstName = get(pickerInfo, 'name', get(pickerInfo, 'email'));
            if (isEmpty(firstName)) return 'Sin Asignar';
            return `${firstName} ${get(pickerInfo, 'lastName', '')}`;
        }
        return `${get(data, 'user.firstName', 'Sin')} ${get(data, 'user.lastName', 'Asignar')}`;
    };

    const resolveModalProps = (data) => {
        return {
            modal: ({ onClose }) => (
                <FlexContainer>
                    <UserSearchSelect
                        salesChannelId={salesChannelId}
                        filters={filters}
                        onSubmit={(...params) => handleSubmit(...params, onClose)}
                        onReset={onClose}
                        defaultValue={get(data, 'user', {
                            email: get(pickerInfo, 'email', ''),
                            firstName: get(pickerInfo, 'name', ''),
                            lastName: get(pickerInfo, 'lastName', ''),
                            id: get(pickerInfo, 'email', '')
                        })}
                        insideModal
                    />
                </FlexContainer>
            ),
            modalProps: {
                title: <Text text={`Asignar Shopper - Pedido ${cleanOrderId(id)}`} size={22} strong />,
                closable: true,
                destroyOnClose: true,
                footer: null
            }
        };
    };

    const renderPickerName = ({ data }) => (
        <Truncate maxWidth='180'>
            <Text size={11} text={resolvePickerName(data)} />
        </Truncate>
    );

    const resolveRender = ({ status, ...data }) => {
        if (render) {
            return (
                <ModalOpener {...resolveModalProps(data)}>
                    { render() }
                </ModalOpener>
            );
        }
        return (
            <Row noWrap justify='center' align='center' style={{ maxWidth, ...styles }}>
                { renderPickerName({ data }) }
                <HasPermissions to={permissions || ['order-detail-page:assign-picker']}>
                    <FlexContainer justify='flex-end'>
                        <Tooltip placement='right' title={<Text text='Asignar Shopper' color='#ffffff' />}>
                            <MobileWrapper hide={assignDisabled} showDesktop>
                                <ModalOpener {...resolveModalProps(data)}>
                                    <Button
                                        link
                                        style={{ border: 'none' }}
                                        backgroundColor='transparent'
                                        disabled={!includes(
                                            validStatuses,
                                            initialState ? get(pickingInfo, 'status.code', 0) : get(data, 'order.status', 0),
                                            validStatuses
                                        ) || !hasPermissionToThisStore}
                                    >
                                        <AppIcon name='ic-edit' size='12' />
                                    </Button>
                                </ModalOpener>
                            </MobileWrapper>
                        </Tooltip>
                    </FlexContainer>
                </HasPermissions>
            </Row>
        );
    };

    const handleSubmit = (userSelected, { setSubmitting }, onCloseModal) => {
        setInitialState(false);
        console.log('should submit', userSelected);
        setSubmitting(true);
        onSelectPicker(userSelected, salesChannelId)
            .then(() => onCloseModal())
            .catch(() => console.log('should log error'));
    };

    const defaultRender = (data, loading) => (
        <Loading loading={loading}>
            { resolveRender(data) }
        </Loading>
    );

    return (
        <QueryGetAssignedInfo variables={{ id }} fetchPolicy='network-only' skip={initialState}>
            {({ data, loading }) => defaultRender(data, loading)}
        </QueryGetAssignedInfo>
    );
};

OrderPickerManager.propTypes = {
    id: string,
    onSelectPicker: func,
    render: any,
    filters: object,
    maxWidth: string,
    permissions: array,
    salesChannelId: oneOfType([string, number]),
    pickerInfo: object,
    pickingInfo: object,
    assignDisabled: bool,
    hasPermissionToThisStore: bool,
    styles: object
};

OrderPickerManager.defaultProps = {
    pageSize: 5,
    pages: 1,
    rowSelection: {},
    hasPermissionToThisStore: true,
    styles: {}
};

export default OrderPickerManager;
